import { Component, Input, OnInit, Output, EventEmitter, ViewChild, HostListener, AfterViewInit, TemplateRef, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { pinsheetDateAction } from 'src/app/store/actions/pinsheet.action';

@Component({
  selector: 'app-pinsheet-grid',
  templateUrl: './pinsheet-grid.component.html',
  styleUrls: ['./pinsheet-grid.component.scss']
})
export class PinsheetGridComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() isExternalAccess:boolean = false
  @ViewChild("has18Grid") has18Grid: any;
  @ViewChild("colorIndicationLegend") colorIndicationLegend: TemplateRef<any>;
  @Input() page: string ="pinsheet";
  @Input() summaryData: any = [];
  @Input() has27Green: boolean = false;
  @Input() has36Green: boolean = false;
  @Input() isMultiplePinsheetCourse: boolean = false;
  @Input() cols: any;
  @Input() rowHeight: any;
  @Input() has27Course1: any = [];
  @Input() has27Course2: any = [];
  @Input() has27Course3: any = [];
  @Input() has36Course1: any = [];
  @Input() has36Course2: any = [];
  @Input() has36Course3: any = [];
  @Input() has36Course4: any = [];
  @Input() primaryGreens: any = [];
  @Input() secondaryGreens: any = [];
  @Input() courseList: any;
  @Input() user: boolean = false;
  @Input() currentDate = new Date();
  @Input() showMessage: boolean = true;
  @Input() showStimp: boolean = false
  @Output() updateEdgeLimit = new EventEmitter<any>();
  @Input() colorIndication: boolean = false
  @Input() isDesktop: boolean = false;
  @Input() isApacheCourse: boolean = false;
  @Input() selectedGreen: string = '';
  @Input() zones: any = [];
  @Input() externalAccessKey:any = null;
  @Input() selectedHoleLayoutTypeId: any = 1;
  @Input() teeBoxDetails:any = [];
  @Input() showTeeBoxDistance: boolean = true;
  teeBoxData: any = []
  showTables: boolean = true
  getEdgeHoleTooltipMessage: any = {
    'Limit' : 'An Edge Hole is selected due to the limit set in the EDGE RULE',
    'Forced' : 'An Edge Hole is selected due to no other availabe holes',
    'Manual' : 'An Edge Hole is manually selected by an admin or a super admin',
    'LimitReverted' : 'An Edge Hole was selected then tried regenerating and selected a Non Edge Hole',
    'LimitForced' : 'An Edge Hole was selected then tried regenerating and again selected an Edge Hole due to no other available holes',
    null : null
  }
  hoveredGreenName: string;
  moistureValue: number;
  ecValue: number;
  salinityIndexValue: number;
  surfaceHeatValue: number;
  soilTempValue: number;
  previousSelectedGreen: string;
  previousSelectedElementID: string;
  isShowDetails: boolean = true

  constructor(
    private store: Store,
    private dialog: MatDialog
  ) { 
    this.showTables = window.innerWidth >= 768
    if(this.page == 'pinsheet')
      this.rowHeight = window.innerWidth > 1200 ? '220' :  '180'
    else if(this.page == 'externalPinsheet') 
      this.rowHeight = this.cols == 6 ? '220' :  '180'

    // if(this.summaryData) {
      // this.setHolesCount()
    // }
  }
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.showTables = window.innerWidth >= 768
    this.setCols();
    if(this.page == 'pinsheet')
      this.rowHeight = window.innerWidth > 1200 ? '220' :  '180'
    else if(this.page == 'externalPinsheet') 
      this.rowHeight = this.cols == 6 ? '220' :  '180'
  }   

  ngOnInit(): void {
    // this.setHolesCount()
  }

  ngAfterViewInit() {
    this.setCols()
    if(this.page == 'pinsheet')
      this.rowHeight = window.innerWidth > 1200 ? '220' :  '180'
    else if(this.page == 'externalPinsheet') 
      this.rowHeight = this.cols == 6 ? '220' :  '180'
    
    // this.setHolesCount()
  }

  resetSelection() {
    this.selectedGreen = ''
  }

  setCols() {
    let width = this.has18Grid.nativeElement.offsetWidth;
    if (width <= 768) {
      this.cols = 3
    }
    else {
      this.cols = 6
    }
  }

  redirectPinsheetDetails() {
    if (!this.user) {
      let pinsheetDate = this.currentDate
      this.store.dispatch(pinsheetDateAction({ pinsheetDate }))
    }
  }

  updateEdgeGreensLimit(e: any, courseId: any) {
    this.updateEdgeLimit.emit({courseId: courseId, limit: e})
  }

  openColorIndicationLegendDialog() {
    this.dialog.open(this.colorIndicationLegend, { disableClose: true })
  }

  showDetails(greenName: any, elementId: string) {
    this.hideDetails(this.previousSelectedElementID)
    this.isShowDetails = (greenName === this.previousSelectedGreen) ? !this.isShowDetails : true
    this.selectedGreen = greenName
    const element = document.getElementById(elementId);
    var greenNumber = greenName.toString().padStart(2, '0')
    const zone = this.zones.find((g: any) => {
      const zonePattern = greenNumber.replace(/([A-Za-z])/, ' $1').toLowerCase(); // Replace '18L' with '18 l', case-insensitive
      const regex = new RegExp(`^${zonePattern} green$`, 'i'); // Create a case-insensitive regex
      
      return regex.test(g.zone_name.toLowerCase().replace(/\s+/g, ' ').trim()); //Compare zone_name and regex and return true or false
    });
    if(element && zone) {
      element.style.display = this.isShowDetails ? 'block' : 'none';
    }
    this.hoveredGreenName = greenName
    this.moistureValue = zone.conditions.moisture_avg
    this.ecValue = zone.conditions.ec_avg
    this.salinityIndexValue = zone.conditions.salinity_index_avg
    this.surfaceHeatValue = zone.conditions.surface_heat_f_avg
    this.soilTempValue = zone.conditions.soil_temp_f_avg
    this.previousSelectedGreen = greenName
    this.previousSelectedElementID = elementId
  }

  hideDetails(elementId: string) {
    const element = document.getElementById(elementId);
    if(element) {
      element.style.display = 'none';
    }
  }
  getGreenTeeBoxes(greenId: number) {
    const greenTeeBoxData = this.teeBoxData.find((tb: any) => tb.GreenId == greenId);
    if (!greenTeeBoxData || !Array.isArray(greenTeeBoxData.TeeBox)) return [];

    return greenTeeBoxData.TeeBox.filter((t: any) => t.IsActive);
  }

  getTeeBoxDistance(distance: number|string, center: number|string) {
    return Number(distance) + Number(center);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['teeBoxDetails'] != undefined){
      this.teeBoxData = this.teeBoxDetails
    }
  }


}
